(() => {
  const clean = () => {
    const walker = document.createTreeWalker(document, NodeFilter.SHOW_COMMENT);
    const boundaries = [];
    while (walker.nextNode()) {
      if (/^(?:BEGIN (?:app block:|sections:)|END (?:app block|sections:))/.test(walker.currentNode.data.trim())) {
        boundaries.push(walker.currentNode);
      }
    }
    boundaries.forEach(node => node.remove());
    document.querySelectorAll('script:not([src])').forEach(script => {
      if (!script.textContent.includes('var customDocumentWrite = function(content)')) return;
      script.textContent = script.textContent.replace(/\/\/ (?:no-op|Try the sendBeacon API|sendBeacon was not successful|XHR beacon)[ \t]*(?=\r?$)/gm, '');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean, { once: true });
  else clean();
})();
